import { render, staticRenderFns } from "./project_settings.vue?vue&type=template&id=56be1e20&scoped=true&"
import script from "./project_settings.vue?vue&type=script&setup=true&lang=ts&"
export * from "./project_settings.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./project_settings.vue?vue&type=style&index=0&id=56be1e20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be1e20",
  null
  
)

export default component.exports